import React, { createContext, useContext, useState, useEffect } from "react";
import { useSocket } from "./SocketProvider";

const ConnectionContext = createContext({
  soulmateUsername: "",
  soulmateStatus: "",
  similarityPercentage: 0,
  isTreeBasedMatch: false,
  setSoulmateUsername: () => {},
  setSoulmateStatus: () => {},
});

export const ConnectionProvider = ({ children }) => {
  const { socket } = useSocket();
  const [soulmateUsername, setSoulmateUsername] = useState("");
  const [soulmateStatus, setSoulmateStatus] = useState("");
  const [similarityPercentage, setSimilarityPercentage] = useState(0);
  const [isTreeBasedMatch, setIsTreeBasedMatch] = useState(false);

  useEffect(() => {
    if (!socket?.on) return;

    const handlePaired = (data) => {
      setSoulmateUsername(data.soulmateUsername);
      setSoulmateStatus(data.soulmateStatus);
      setSimilarityPercentage(data.similarityPercentage || 0);
      setIsTreeBasedMatch(data.isTreeBasedMatch || false);
    };

    socket.on("paired", handlePaired);

    return () => {
      if (socket?.off) {
        socket.off("paired", handlePaired);
      }
    };
  }, [socket]);

  const value = {
    soulmateUsername,
    soulmateStatus,
    similarityPercentage,
    isTreeBasedMatch,
    setSoulmateUsername,
    setSoulmateStatus,
  };

  return (
    <ConnectionContext.Provider value={value}>
      {children}
    </ConnectionContext.Provider>
  );
};

export const useConnection = () => {
  const context = useContext(ConnectionContext);
  if (context === undefined) {
    throw new Error("useConnection must be used within a ConnectionProvider");
  }
  return context;
};